import React from "react"

type Props = {
  className?: string
}

const CounterIcon = ({ className }: Props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2505_41047)">
        <path
          d="M20.6201 14.35V16.73C20.7101 17.35 20.2301 17.91 19.6001 17.91H13.7101C13.0801 17.91 12.6001 17.35 12.6901 16.73V14.44"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.79 13.2H1.97C1.3 13.2 0.75 12.6 0.75 11.85L1.75 2.1C1.75 1.36 2.29 0.75 2.97 0.75H16.56C17.23 0.75 17.78 1.35 17.78 2.1L18.78 10.29"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M4.75 16.87H12.47"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.72998 13.49V16.88"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M19.53 15.16H13.78C13.11 15.16 12.6 14.6 12.72 14L13.17 11.69C13.26 11.22 13.71 10.88 14.23 10.88H19.07C19.59 10.88 20.04 11.22 20.13 11.69L20.58 14C20.7 14.6 20.19 15.16 19.52 15.16H19.53Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export default CounterIcon
